import { useRouteError } from "react-router-dom";
import { EmptyState } from "../../components/empty";
import { BgWrapper } from "../../components/wrapper/bgWrapper";

export const ErrorPage = () => {
  const error = useRouteError();
  console.error("Here's what happened: ", error);

  return (
    <div className="w-full">
      <BgWrapper>
        <EmptyState
          text="Oops! :("
          textClassName="!normal-case !font-normal !max-w-[300px]"
          subtext="Something went wrong."
          subtextClassName="!max-w-[300px] !text-sm"
          ctaText="Reload page"
          ctaClassName="!max-w-[200px]"
          onCTAClick={() => {
            window.location.reload();
          }}
          image="/assets/images/search-glass.png"
        />
      </BgWrapper>
    </div>
  );
};
